// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeRoundGetBoardBody = {
  poolId: string;
  contestId: string;
  roundId: string;
  entryId?: string | null;
};

export type typeRoundGetBoardOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    locked: boolean;
    locksAt: string;
    requiredPickCount: number;
    games: {
      eventId: string;
      homeTeamId: string;
      awayTeamId: string;
      kickoffAt: string;
      locked: boolean;
      liveScore?: { home: number; away: number } | null;
      spread?: {
        current?: number | null;
        locked?: number | null;
        pending: boolean;
      } | null;
      moved?: { reason: "postponed"; pickIsFree: boolean } | null;
      unavailable?: { reason: "alreadyFinished" } | null;
      status?:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
    }[];
    myPicks: {
      eventId: string;
      teamId: string;
      priority: number;
      locked: boolean;
      visibleToPool: boolean;
      outcome?: "win" | "loss" | "push" | "pending";
    }[];
    selectableTeamIds: string[];
    lockedOutTeams: {
      teamId: string;
      reason: "usedThisWindow" | "reuseLimitReached";
      availableAgainAt?: string | null;
    }[];
    skipDeclared: boolean;
    canDeclareSkip?: boolean;
    canUndoSkip?: boolean;
    skipsRemaining?: number | null;
  };
};

export type typeRoundGetBoardOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeRoundGetBoardOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeRoundGetBoardOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaRoundGetBoardBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: { type: "string", maxLength: 3000, minLength: 1 },
    entryId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "contestId", "roundId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createRoundGetBoard(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaRoundGetBoardBody);
  }

  return async function postRoundGetBoard(
    payload: typeRoundGetBoardBody,
  ): Promise<typeRoundGetBoardOutput200 | typeRoundGetBoardOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postRoundGetBoard" failed before calling the network. #57d23425cee6`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#57d23425cee6" },
        },
        data: null,
      } as typeRoundGetBoardOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/round/get-board`,
      httpMethod: "POST",
      options,
    })) as typeRoundGetBoardOutput200 | typeRoundGetBoardOutput400;
  };
}
